import { ProductService } from './product.service';
import { AngularFirestoreCollection, DocumentReference } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { FirebaseDaoBase } from '../table/daos/firebase-dao-base';

import { Product } from './Product';
import { AngularFireStorage } from '@angular/fire/storage';

@Injectable({
  providedIn: "root"
})
export class ProductDao extends FirebaseDaoBase<any> {

  public updateProduct(product: Product, id: any) {
    return this.getCollection().doc(id).update(product)
  }
  public deleteProduct(productId: string) {
    if (productId) {
      return this.getCollection().doc(productId).delete().then(() => { return true });
    }
    return false;
  }

  constructor(public productService: ProductService, public storage: AngularFireStorage) {
    super();
  }

  public getCollection(): AngularFirestoreCollection {
    const collection = this.productService.getCollection();
    return collection;
  }

  public async getDataItems(products?: any[]): Promise<any[]> {
    return Promise.all(products.map(async product => {
      const imageUrl = await this.getProductImageUrl(product._id).catch(() => console.log(`Failed to load image for product Id ${product._id}`))
      if (imageUrl) {
        product.imageUrl = imageUrl
      }
      return product;
    }))
  }

  private getProductImageUrl(docId) {
    const ref = this.storage.ref(`products/${docId}`);
    return ref.getDownloadURL().toPromise()
  }

  public addProduct(product: Product): Promise<DocumentReference> {
    return this.getCollection().add(product);
  }

  public convertValuesToString(dataItem: any, key: string): string {
    switch (key) {
      case "price":
        return new CurrencyPipe("en-US").transform(dataItem[key], "USD");
      default:
        return dataItem[key];
    }
  }
}



